var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('nav',{staticClass:"user-menu"},[_c('ul',{staticClass:"user-menu-list"},[_c('li',{staticClass:"user-menu-item"},[_c('router-link',{attrs:{"to":{name: _vm.profileLink}}},[_vm._v("Настройки")])],1),_vm._v(" "),_c('li',{staticClass:"user-menu-item",on:{"click":_vm.logout}},[_c('a',[_vm._v("Выйти")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }